// extracted by mini-css-extract-plugin
export default {"header":"Header_header__KEhIw","menu":"Header_menu__8VYQ4","search_chats":"Header_search_chats__Ib9My"};